import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { swManager } from './services/serviceWorkerManager';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register Service Worker for PWA functionality
if (process.env.NODE_ENV === 'production') {
  swManager.register({
    onSuccess: () => {
      console.log('[PWA] Service Worker registered successfully');
    },
    onUpdate: (registration) => {
      console.log('[PWA] New content available, please refresh');
      // Optionally notify user to update
      if (window.confirm('New version available! Reload to update?')) {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      }
    },
    onError: (error) => {
      console.error('[PWA] Service Worker registration failed:', error);
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
